import React, { Component, useState } from 'react';
import DrawerCustom from '../../components/DrawerCustom';
import ButtonCustom from '../../components/ButtonCustom';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Typo from '../../components/CustomTypo';
import { Grid, Menu, ListItem, ListItemIcon, ListItemText, Button, ListItemSecondaryAction, InputBase } from '@material-ui/core';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { ArrowDownIcon, BackOnPrimaryIcon } from '../../components/icons'
import CustomizedCircularProgress from '../../components/CircularProgress'
import ComponentItems from './ComponentItemsView'
import VariantsItemView from './VariantsItemView';
import UpsellProductsComponent from './UpsellProductsComponent';
const styles = theme => ({
    container: {
        padding: theme.spacing(3, 5, 3, 5),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(3),
        },
    },
    footer: {
        position: 'fixed',
        bottom: theme.spacing(2),
        width: '36%',// lấy chỉ số width ở drawer x 90%
        [theme.breakpoints.down('md')]: {
            width: '45%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '54%',
        },
        [theme.breakpoints.down('xs')]: {
            width: '81%',
        },
    },
    product_image_cover: {
        width: '100%',
        height: 300,
        objectFit: 'contain',
        paddingTop:theme.spacing(2),
        paddingBottom:theme.spacing(2),
        backgroundColor:theme.palette.background.secondary,
    },
    item_list:{
        marginBottom:theme.spacing(1)
    },
    product_item_container: {
        marginTop: theme.spacing(4),
    },
    product_item: {
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.shape.borderRadius2x,
        padding: theme.spacing(3, 5, 3, 5),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
            marginBottom: 0,
        },
    },
    product_item_selected: {
        backgroundColor: theme.palette.background.secondary,
        borderTopLeftRadius: theme.shape.borderRadius2x,
        borderTopRightRadius: theme.shape.borderRadius2x,
        borderBottom: "1px solid",
        borderBottomColor: theme.palette.border.primary,
        padding: theme.spacing(3, 5, 3, 5),
        marginTop: theme.spacing(2),
        marginBottom: 0,
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
            marginBottom: 0,
        },
    },
    menuItemContainer: {
        backgroundColor: theme.palette.background.secondary,
        borderBottomLeftRadius: theme.shape.borderRadius2x,
        borderBottomRightRadius: theme.shape.borderRadius2x,
    },
    item_quantity: {
        backgroundColor: theme.palette.background.secondary,
        width: '90%',
        marginRight: '10%',
        borderRadius: theme.shape.borderRadius5x,
        // height:40,
        padding: theme.spacing(0,2,0,2)
    },
    price:{
        position:'absolute',
        right: theme.spacing(3)
    },
    buttonBack: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        backgroundColor: theme.palette.button.primary.backgroundColor,
        borderRadius: theme.spacing(8),
        cursor: "pointer",
        textAlign: "center",
        touchAction: "manipulation",
        position: 'absolute',
        top:theme.spacing(5),
        right:theme.spacing(5),
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    add_note_content:{
        minHeight: theme.spacing(20),
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        padding: theme.spacing(4),
        marginBottom:theme.spacing(2),
        marginTop: theme.spacing(2)
    },
    bottom_item: {
        marginBottom: theme.spacing(24),
    },
    //price terms
    container_box: {
        backgroundColor: theme.palette.background.secondary,
        borderRadius: 16,
        padding: theme.spacing(3, 5, 3, 5),
        marginTop: 6,
        marginBottom: 6,
        borderWidth: 1,
        borderColor: 'transparent'
    },
    item: {
        borderWidth: 1,
        backgroundColor: theme.palette.background.card,
        borderColor: theme.palette.border.primary,
        borderRadius: 8,
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 8,
        paddingRight: 8,
        marginRight: 8,
        marginBottom: 8,
        alignItems: 'center',
        flexDirection: 'row',
        "&:hover": {
            cursor: 'pointer',
        },
        color: theme.palette.text.onPrimary,
    },
    item_active: {
       backgroundColor: theme.palette.button.primary.backgroundColor,
        borderColor: "transparent",
        color: theme.palette.button.primary.color,
    },
    circle_main: {
        width: 6,
        height: 6,
        borderRadius: 6,
        backgroundColor: theme.palette.text.onPrimary,
        marginRight: theme.spacing(1)
    }
})

function ExtraItemView(props) {
    const { classes, t, currency, open, onClose, selectedProduct, mode, showLoading, showValidationVariant, upsellProducts, handleOnChangeNote} = props;
    return (
        <DrawerCustom open={open} onClose={onClose} fullScreen>
            <div>
                <Grid xs={12} item container onClick={() => props.onGoBack('menu')}>
                    <Grid color='gray' className={classes.buttonBack}>
                        <BackOnPrimaryIcon/>
                    </Grid>
                </Grid>
                <ProductImage classes={classes} image={dataUtil.getImageByUsageTypePortal(selectedProduct.creatives, usage_type.product_detail)} />
            </div>
            <Grid item xs={12} className={classes.container}>
                <Typo mg_top_sm variant='h3' color='onPrimary'>{selectedProduct.name}</Typo>
                <Typo mg_top_sm variant='body1' color='onPrimary'>{selectedProduct.description}</Typo>
                {/* {showLoading && <CustomizedCircularProgress />} */}
                <PriceTerms 
                    classes={classes}
                    t={t}
                    price_selected={props.price_selected} 
                    product_info={props.product_detail} 
                    currency={currency} 
                    onSelectPriceTerm={props.onSelectPriceTerm}/>
                {props.variations && props.variations.length > 0 && <Grid xs={12} item className={classes.product_item_container}>
                    <VariantsItemView 
                        classes={classes} 
                        currency={currency}
                        product_type={selectedProduct.type} 
                        variations={props.variations} 
                        variationSelected={props.variationSelected} 
                        onSelectedVariation={props.onSelectedVariation}
                        showValidationVariant={showValidationVariant}
                    />
                </Grid>}
                {props.components && props.components.length > 0 && <Grid xs={12} item className={classes.item_list}>
                    <ComponentItems 
                        classes={classes} 
                        currency={currency}
                        product_type={selectedProduct.type} 
                        components={props.components} 
                        componentsSelected={props.componentsSelected} 
                        onSelectComponent={props.onSelectComponent}
                        componentRequireSelected={props.componentRequireSelected}
                    />
                </Grid>}
                <Grid item xs={12} className={classes.add_note_content}>
                        <InputBase multiline color='primary' fullWidth autoFocus placeholder={t('add_your_note')} value={props.notes} onChange={(event)=>handleOnChangeNote(event)}/>
                    </Grid>
                {upsellProducts && upsellProducts.length > 0 && <UpsellProductsComponent currency={props.currency} upsellProducts={upsellProducts} onSelectUpsellProduct={props.onSelectUpsellProduct}/>}
                <Grid item className={classes.bottom_item}/>
                <Grid item xs={12} container direction='row' className={classes.footer} >
                    <Grid item xs={4} sm={3}container direction='row' justify='center' alignItems='center'>
                        <Grid item xs={12} container direction='row' justify='center' alignItems='center' className={classes.item_quantity}>
                            <Grid item xs={4} container justify='center' alignItems='center'>
                                <Typo variant='action' onClick={() => props.onItemQuantityChange(false)}>-</Typo>
                            </Grid>
                            <Grid item xs={4} container justify='center' alignItems='center'>
                                <Typo variant='caption1'>{props.quantity}</Typo>
                            </Grid>
                            <Grid item xs={4} container justify='center' alignItems='center'>
                                <Typo variant='action' onClick={() => props.onItemQuantityChange(true)}>+</Typo>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={8} sm={9}>
                        {mode=== 'edit' ? 
                        <ButtonCustom fullWidth color='primary' onClick={props.onUpdateToCart}>{t('update_cart')} {props.totalAmount.toFixed(2)}</ButtonCustom> :
                        <ButtonCustom fullWidth color='primary' onClick={()=>props.onAddToCart()} disableTextTransform >{t('add_to_cart')} {currency}{props.totalAmount.toFixed(2)}</ButtonCustom>}
                    </Grid>
                </Grid>
            </Grid>
        </DrawerCustom>
    );
}
function PriceTerms(props) {
    const {classes, t} = props;
    let product_info = props.product_info;
    console.log("product_info:", product_info);
    console.log("price_selected:", props.price_selected);
    if (product_info && product_info.classification == "TERMED_SERVICE") {
        let pricing = product_info.pricing;
        let price_selected = props.price_selected;
        return (
            <Grid item xs={12} className={classes.container_box}>
                <Grid item xs={12} container direction="row" style={{ marginBottom: 8 }}>
                    <Grid item xs={10}>
                        <Typo variant="subtitle2">{"Price Terms"}</Typo>
                    </Grid>
                    <Grid item xs={2} container alignItems='center' justify='flex-end'>
                        <ArrowDownIcon />
                    </Grid>
                </Grid>
                {pricing.map((price, index) => {
                    let price_term = price.price_terms && price.price_terms.length > 0 ? price.price_terms[0] : null;
                    if (price_term) {
                        let isSelected = price_selected && price_selected.id == price.id;
                        return (
                            <Grid item key={index + 1} className={[classes.item, isSelected ? classes.item_active : undefined].join(' ')} onClick={() => props.onSelectPriceTerm(price)}>
                                <Grid item>
                                    <Typo>{props.currency}{price.price ? price.price.toFixed(2) : "0.00"} {t('per')} {price_term.billing_period ? price_term.billing_period.duration + " " + price_term.billing_period.uot.toLowerCase() : ""}</Typo>
                                    <Grid item xs={12} container direction='row' style={{ marginTop:8, alignItems:'center' }}>
                                        <Grid item className={classes.circle_main} />
                                        <Typo capitalize>{price.rate_model} - {t(price.tax_model)}</Typo>
                                    </Grid>
                                    <Grid item xs={12} container direction='row' style={{ marginTop:8,alignItems:'center' }}>
                                        <Grid item className={classes.circle_main} />
                                        <Typo>{t('tax_model_desc') + price_term.terms_billing_cycles + t('tax_model_desc_1')}</Typo>
                                    </Grid>
                                    {price_term.auto_renewed && <Grid item xs={12} container direction='row' style={{ marginTop:8, alignItems:'center' }}>
                                        <Grid item className={classes.circle_main} />
                                        <Typo>{t('auto_renewed')}</Typo>
                                    </Grid>}
                                    <Grid item xs={12} container direction='row' style={{ marginTop:8,alignItems:'center' }}>
                                        <Grid item className={classes.circle_main} />
                                        <Typo>{price_term.contract_period ? price_term.contract_period.duration + " " +  price_term.contract_period.uot.toLowerCase() + " " + t('contract_period') : t('no_contract_period')}</Typo>
                                    </Grid>
                                    <Grid item xs={12} container direction='row' style={{ marginTop:8, alignItems:'center' }}>
                                        <Grid item className={classes.circle_main} />
                                        <Typo>{price_term.trial_period ? price_term.trial_period.duration + " " +  price_term.trial_period.uot.toLowerCase() + " " + t('trial_period') : t('no_trial_period')}</Typo>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )
                    } return null;
                })}
            </Grid>
        )
    } return null;
}
function ProductImage(props) {
    if (props.image && props.image.url) {
        return <img className={props.classes.product_image_cover} src={props.image.url} />
    } return null
}
export default withStyles(styles)(withTranslation()(ExtraItemView));